import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Section, Title } from "@/components/UI";
import { useFeatures } from ".";
import { FeaturesPreview } from "./FeaturesPreview";
import { FeaturesDetails } from "./FeaturesDetails";
export const featuresTestId = "cdp-features";
export const Features = () => {
    const { t } = useI18n();
    const features = useFeatures();
    const { featuresRef } = useRefsContext();
    if (!features || (features === null || features === void 0 ? void 0 : features.hideSection))
        return null;
    return (_jsxs(Section, { ref: featuresRef, testId: featuresTestId, children: [_jsx(Title, { title: t("features.title"), testId: `${featuresTestId}-title`, variant: "section", id: "features" }), _jsx(FeaturesPreview, {}), _jsx(FeaturesDetails, {})] }));
};
